import axios from 'axios'

export default  {

  postData(url, data, success) {
    var that = this;
    axios.post('/api/'+ url , data)
      .then(function (res) {
        // console.log('url：',url);
        // console.log('data：',data);
        // console.log('tool返回数据：',res.data);
 
        /** 成功 : 1 **/
        if (res.data.code == 200) {
          success && success(res.data);

        }
        /** 失败 : 0/3 **/
        else {

          /** 提示错误信息 : 0  **/
          if (res.data.code == 400) {
            // alert(res.data.msg);
          }

          /** 重新登录 : 3  **/
          else if (res.data.code == "3"){
            // alert(res.data.message);
          }
        }

      })
      .catch(function (error) {
        console.log(error);
      });

  },

}




// WEBPACK FOOTER //
// ./src/assets/tjs/tool.js